import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Payment({ result }) {
  const { strings } = useLanguage();
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (result === 'success') {
      setMessage(strings.pages.payment.successMessage);
    } else if (result === 'cancel') {
      setMessage(strings.pages.payment.cancelMessage);
    }
  }, [result, strings]);

  return (
    <section className="hero">
      <div className="hero-content">
        <p className="eyebrow">{strings.pages.payment.eyebrow}</p>
        <h1>{strings.pages.payment.title}</h1>
        <p className="hero-sub">{message}</p>
      </div>
    </section>
  );
}
